import React, { Component } from "react";

import UI from "../../../actions/ui-helper";
import StringUtil from "../../../actions/string";

class ConsultaEmpresaResultado extends Component {

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    let tdStyle = { width: '1%' };

    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table key={StringUtil.uuid(5)} id={this.tableId} className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>CNPJ</th>
                    <th>Razão Social</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((empresa, i) => {
                    return (
                      <tr key={empresa.id}>
                        <td>{empresa.id}</td>
                        <td>{empresa.cnpj}</td>
                        <td>{empresa.razaoSocial}</td>
                        <td style={tdStyle}>
                          <button
                            onClick={() => this.props.onEditar(empresa, i)}
                            className="btn btn-xs btn-light btn-option icon-btn"
                            type="button">
                            <i className="fa fa-cog"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaEmpresaResultado;
